import React, { Component } from 'react';
import { Link } from 'react-router';

class ProfileTabs extends Component {
  render () {
    return(
      <nav>
        <ul className="tabList">
          <li className="tabList-item is-selected">
            <Link to="" className="link tabList-link">About</Link>
          </li>
          <li className="tabList-item">
            <Link to="#asg" className="tabList-link">Trips <span>2</span></Link>
          </li>
        </ul>
      </nav>
    );
  }
}

export default ProfileTabs;



// WEBPACK FOOTER //
// ./src/components/pages/Profile/ProfileTabs.jsx